import { addMonths } from 'date-fns'
import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { BFFComponent } from '@opallabs/api'
import { formatToDateString } from '../../util/datestring'

type ConnectorCandidate = BFFComponent<'connector_candidate'>
export const connectorCandidateFactory: Factory<ConnectorCandidate> =
  Factory.define<ConnectorCandidate>(
    ({ sequence }) =>
      ({
        block: {
          id: uuidV4(),
          name: `Connector Candidate ${sequence}`,
        },
        category_type: null,
        start_date: formatToDateString(new Date()),
        end_date: formatToDateString(addMonths(new Date(), 1)),
        supportive_view_id: uuidV4(),
        supportive_category_id: uuidV4(),
        child_candidates: [],
      }) satisfies ConnectorCandidate
  )
